// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C3Nj","icon":"styles_icon__3Y_aU"};